import { API } from '@/models/core'
import { Enum } from '@/helpers/enum'

export const ContestRewardsKinds = new Enum({
  NoRewards: 'NoRewards',
  MedalByRank: 'MedalByRank',
  ChipsByRank: 'ChipsByRank',
  ChipsByPoint: 'ChipsByPoint'
})
export class boostPlayer {
  constructor (bowler, rate) {
    this.bowler = bowler
    this.rate = rate
  }
}

export class Rule {
  constructor () {
    this.key = null
    this.app = null
    this.name = null
    this.desc = null
    this.boost_names = ['Captain', 'Vice-Captain']
    this.min_participants = null
    this.max_participants = null
    this.min_players_per_team = 11
    this.max_players_per_team = 11
    this.max_players_by_role = {}
    this.min_players_by_role = {}
    this.closing_time = '30 Minutes'
    this.credits = 100
    this.buy_in_chips = null
    this.min_matches = null
    this.max_matches = null
    this.min_players_per_match = null
    this.max_players_per_match = null
    this.min_teams = null
    this.max_teams = null
    this.min_players = null
    this.max_players = null
    this.credits_boost = {}
    this.credits_model = null
    this.is_archived = false
  }

  static createRule (postData) {
    postData.app = API.faKey
    let params = postData
    return API.instance().post(`/fantasy-app/${API.faKey}/rules/`, params).then((resp) => {
      return resp
    })
  }

  static getAllRules (cursor) {
    let url
    if (cursor) {
      url = `fantasy-app/${API.faKey}/public_rules/?last=${cursor.last}&&lastkey=${cursor.lastkey}&&total=${cursor.total}`
    } else {
      url = `fantasy-app/${API.faKey}/public_rules/`
    }
    let params = {}
    return API.instance().get(url, params).then((resp) => {
      return Rule.ruleCreateFromJson(resp.data.data)
    })
  }

  static getAppRules (cursor) {
    let url
    if (cursor) {
      url = `fantasy-app/${API.faKey}/app_rules/?last=${cursor.last}&&lastkey=${cursor.lastkey}&&total=${cursor.total}`
    } else {
      url = `fantasy-app/${API.faKey}/app_rules/`
    }
    let params = {}
    return API.instance().get(url, params).then((resp) => {
      return Rule.ruleCreateFromJson(resp.data.data)
    })
  }

  static ruleCreateFromJson (raw) {
    let rule = Object.assign(raw)
    for (let ruleInfo of rule.rules) {
      ruleInfo['show'] = false
    }
    return rule
  }

  static getRule (ruleKey) {
    let params = {}
    return API.instance().get(`/fantasy-app/${API.faKey}/rules/?key=${ruleKey}`, params).then((resp) => {
      return resp.data.data
    })
  }


}

export let participants = [
  {'key': '1'},
  {'key': '2'},
  {'key': '3'},
  {'key': '4'},
  {'key': '5'},
  {'key': '6'},
  {'key': '7'},
  {'key': '8'},
  {'key': '9'},
  {'key': '10'},
  {'key': '11'}
]

export class Reward {
  constructor () {
    this.key = null
    this.app = null
    this.name = null
    this.desc = null
    this.kind =  null
    this.rank_break_points = []
    this.rank_medals = []
    this.rank_chips = []
    this.default_participants_chips = null
    this.chips_per_point = null
    this.max_chips = null
    this.is_archived = false
  }
  static getReward (rewardKey) {
    let params = {}
    return API.instance().get(`fantasy-app/${API.faKey}/reward-system/?key=${rewardKey}`, params).then((resp) => {
      return Reward.createFromJson(resp.data.data)
    })
  }

  static getAllRewards (cursor) {
    let url
    if (cursor) {
      url = `fantasy-app/${API.faKey}/public_rewards/?last=${cursor.last}&&lastkey=${cursor.lastkey}&&total=${cursor.total}`
    } else {
      url = `fantasy-app/${API.faKey}/public_rewards/`
    }
    let params = {}
    return API.instance().get(url, params).then((resp) => {
      return resp.data.data
    })
  }

  static getAppRewards (cursor) {
    let url
    if (cursor) {
      url = `fantasy-app/${API.faKey}/app_rewards/?last=${cursor.last}&&lastkey=${cursor.lastkey}&&total=${cursor.total}`
    } else {
      url = `fantasy-app/${API.faKey}/app_rewards/`
    }
    let params = {}
    return API.instance().get(url, params).then((resp) => {
      return resp.data.data
    })
  }

  static createReward (postData, medalArray) {
    postData.rank_medals = []
    postData.rank_break_points = []
    postData.rank_chips = []
    if (medalArray) {
      for (let medal of medalArray) {
        if (postData.kind == 'MedalByRank') {
          postData.rank_medals.push(medal.name)
          postData.rank_break_points.push(medal.range)
          postData.rank_chips.push(medal.rank_chips)
        } else if (postData.kind == 'ChipsByRank'){
          postData.rank_medals = null
          postData.rank_break_points.push(medal.range)
          postData.rank_chips.push(medal.name)
        }
      }
    }
    postData.app = API.faKey
    let params = postData
    return API.instance().post(`fantasy-app/${API.faKey}/reward-system/`, params).then((resp) => {
      return resp.data.data
    })
  }

  static createFromJson (raw) {
    let obj = new Reward()
    let reward = Object.assign(obj, raw)
    reward.kind = ContestRewardsKinds.parse(reward.kind)
    // let medalByRank = []
    // if (reward.kind.value == 'MedalByRank' && reward.rank_medals) {
    //   for (let medal in reward.rank_medals) {
    //     let medalObj = new Medal()
    //     medalObj.name = reward.rank_medals[medal]
    //     if (reward.rank_break_points) {
    //       medalObj.range = reward.rank_break_points[medal]
    //     }
    //     if (reward.rank_chips) {
    //       medalObj.rank_chips = reward.rank_chips[medal]
    //     }
    //     medalByRank.push(medalObj)
    //   }
    // } else if (reward.kind.value == 'ChipsByRank' && reward.rank_chips) {
    //   for (let medal in reward.rank_chips) {
    //     let medalObj = new Medal()
    //     medalObj.name = reward.rank_chips[medal]
    //     if (reward.rank_break_points) {
    //       medalObj.range = reward.rank_break_points[medal]
    //     }
    //     medalByRank.push(medalObj)
    //   }
    // }
    // reward.medal_by_rank = medalByRank
    // obj = Object.assign(obj, raw)
    return reward
  }
}

export class Medal {
  constructor (name = null, range = null, rankchips = null)  {
    this.name = name
    this.range = range
    this.rank_chips = rankchips
  }
}
